import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from '../reducers/furniture';
import {
  Material,
  MAX_CORNER_HEIGHT,
  PaneMaterial,
} from 'lib/modelBuilder/constants';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { CustomPiece } from '../../../lib/modelBuilder/pieces/CustomPiece';
import { Batten } from '../../../lib/modelBuilder/pieces/Batten';
import { makeSelectLastHistoryCabinet } from './history';

/**
 * Direct selector to the app state domain
 */

export const selectCabinetDomain = (state: ApplicationRootState) => {
  if (state.configurator) {
    return state.configurator.furniture || initialState;
  }
  return initialState;
};

export const makeSelectFurniture = () =>
  createSelector(selectCabinetDomain, substate => substate.furniture);

export const makeSelectPreview = () =>
  createSelector(selectCabinetDomain, substate => substate.preview);

export const makeSelectLoadingFurniture = () =>
  createSelector(selectCabinetDomain, substate => substate.loading);

export const makeSelectSelectedIdCabinet = () =>
  createSelector(selectCabinetDomain, substate => substate.selectedId);

export const makeSelectIsFurnitureMode = () =>
  createSelector(selectCabinetDomain, substate => !substate.selectedId);

export const makeSelectFurnitureImage = () =>
  createSelector(selectCabinetDomain, substate => substate.image);

export const makeSelectCabinetImages = () =>
  createSelector(selectCabinetDomain, substate => substate.images);

export const makeSelectCabinet = () =>
  createSelector(selectCabinetDomain, (substate): Cabinet | null => {
    if (substate.selectedId && substate.furniture)
      return substate.furniture.get(substate.selectedId);
    return null;
  });

export const makeSelectIsCabinetLoading = () =>
  createSelector(selectCabinetDomain, (substate): boolean => substate.loading);

export const makeSelectIsCabinetReady = () =>
  createSelector(
    makeSelectCabinet(),
    (cabinet): boolean => !!(cabinet && cabinet.range),
  );

export const makeSelectCabinetWidth = () =>
  createSelector(makeSelectCabinet(), (cabinet): number => {
    if (cabinet) return cabinet.width;
    return 0;
  });

export const makeSelectCabinetDepth = () =>
  createSelector(makeSelectCabinet(), (cabinet): number => {
    if (cabinet) return cabinet.depth;
    return 0;
  });

// export const makeSelectCabinetHeight = () =>
//   createSelector(
//     makeSelectCabinet(),
//     (cabinet): number => {
//       if (cabinet) return cabinet.height;
//       return 0;
//     },
//   );

export const makeSelectSupportFootCabinet = () =>
  createSelector(makeSelectLastHistoryCabinet(), (cabinet): CustomPiece<
    Batten
  > | null => {
    if (cabinet && cabinet.feets && cabinet.feets.length > 1)
      return cabinet.feets[0];
    return null;
  });

export const makeSelectCanAddShelf = () =>
  createSelector(makeSelectCabinet(), (cabinet): boolean => {
    if (cabinet && cabinet.shelves)
      return cabinet.getCornerHeight() < MAX_CORNER_HEIGHT;
    return true;
  });

export const makeSelectShelves = () =>
  createSelector(makeSelectCabinet(), (cabinet): Shelf[] => {
    if (cabinet) {
      return cabinet.shelves;
    }
    return [];
  });
